import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserCreateMatch = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解3：创建比赛
          </Title>
          <div className="my-4">
            <Image src="/manual/create_match/1.png" alt="" />
          </div>
          <div className="text-lg">
            <p>比赛名：必填项，录入比赛的名称。比赛名称可在比赛设置→基础信息的比赛名称中更改。</p>
            <p>比赛类型：必选项，根据赛事要求选择比赛的类型。</p>
            <p>是否为测试赛：测试赛会对人数，轮次数有一定限制，但不占用创建比赛的额度。</p>
            <p>是否为测试赛如果选错了，可以在比赛设置→VIP 专区内更改。</p>
            <div className="my-4">
              <Image src="/manual/create_match/2.png" alt="" />
            </div>
            <p>比赛类型详解：</p>
            <p>1、组队赛。固定搭档，以队伍（2 人）为单位进行的比赛，按照队伍成绩进行排名。</p>
            <p>2、单人赛。每轮比赛均改变对家和对手，按照个人成绩进行排名。</p>
            <p>3、循环赛。每支队伍都和其他队伍进行一轮比赛，N 队打 N-1 轮，采取逆时针轮转法编排，按照队伍成绩进行排名。</p>
            <p>
              4、团团转。固定级牌（通常为一直打“2”）；对家不固定，每副比赛均可通过事先约定的方式重新配对；每副牌按照和对家两个人所取得的名次计算成绩。按照个人成绩进行排名。选择团团转方式时，选
              手选择正确的桌号入座即可，至于桌次编排上的对家信息可以忽略，成绩对应选手本人记录即可（是按个人成绩进行记分的）。
            </p>
            <p>6、超分赛（过 A 继续打）。在组队赛的基础上，每轮比赛限定时间不限定副数，A 非必打，可根据实际升级数跳过 A，比赛时间未结束前，过A 继续打。按照队伍成绩进行排名。</p>
            <p>
              7、米切尔复式赛。在组队赛的基础上，采用米切尔移位编排法（南北不动，东西方往高桌号移位，牌向低桌号传），每桌东西方打一样的牌，南北方打一样的牌。按照队伍成绩进行排名，东西方和南北方各产生
              1 名冠军。
            </p>
            <p>
              8、四人队式开闭室复式赛。比赛分为两个赛区，分别为 A 赛区（开室），B 赛区（闭室）。B 赛区（闭室）不对外开放，两赛区之间不得互相交流和观摩。4 人为 1 队，每队分成 2
              组，其中 2 人为 A 组（开室组），2 人为 B 组（闭室组）。两个赛区分别设置
              1、2、3…号桌。同号桌互为镜像，同一团队的不同组选手分坐两桌，方位相反，同方位牌型相同。同一轮次内 A/B 室的牌型相同。按照队（4 人）的成绩进行排名。
            </p>
            <p>
              9、瑞士偏差分复式赛。在组队赛的基础上，采用瑞士移位编排法（高分对高分，低分对低分，不重复相遇），每桌东西方打一样的牌，南北方打一样的牌。以科学偏差分计算成绩，按照队伍成绩进行排名。
            </p>
            <p>10、联赛。某掼协定制的特殊比赛类型。</p>
            <p>11、团体赛。在组队赛的基础，以团体为单位进行的比赛，按照团体和队伍的成绩分别进行排名。</p>
            <p>注意：不同的vip权限对应不同的比赛类型，具体可在“VIP购买”中 查看</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserCreateMatch, {
  title: '创建比赛与赛制选择 · 灵缇赛事系统使用手册',
  description: '如何在灵缇赛事系统创建比赛:填写比赛名、选择比赛类型(双人赛、单人赛、团团转、循环赛、复式赛、联赛、球拍类等)、测试赛说明及各赛制详解。',
})

export default UserCreateMatch
